import styled from "@emotion/styled";
import { Toolbar, AppBar } from "@mui/material";
import myThemes from "../../themes/Themes";
import { Link } from "@mui/material";
export const NavBar = styled(AppBar)(({ theme }) => ({
  position: "sticky",
  backgroundColor: myThemes[theme].palette.primary,
  height: 80,
  // borderBottom: "1px solid #6c35c7",
  boxShadow: "none",
  justifyContent: "center",
  // borderBottom: "1px solid #2E133A",
}));

export const NavBarItems = styled(Toolbar)(() => ({}));

export const DrawerLink = styled(Link)(() => ({
  fontFamily: "Inter",
  color: "white",
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "20px",
  textTransform: "capitalize",
}));
